import Column from 'antd/lib/table/Column';
import range from 'lodash/range';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';

const dataSourceKeys = range(1, 7);
const columnsData = [
    {
        width: 150,
        key: 'situation',
        dataIndex: 'situation',
    },
    {
        width: 100,
        key: 'emotion',
        dataIndex: 'emotion',
    },
    {
        width: 200,
        key: 'function',
        dataIndex: 'function',
    },
    {
        width: 150,
        key: 'physicalResponse',
        dataIndex: 'physicalResponse',
    },
    {
        width: 150,
        key: 'behavior',
        dataIndex: 'behavior',
    },
    {
        width: 150,
        key: 'consequence',
        dataIndex: 'consequence',
    },
];

interface DataSource {
    key?: string;
    situation: string;
    emotion: string;
    function: string;
    physicalResponse: string;
    behavior: string;
    consequence: string;
}

export const MoreAboutEmotionsStep = withTranslation('cbt')(({ t }: WithTranslation) => {
    const descriptions: string[] = t('week-3.more-about-emotions.descriptions', {
        returnObjects: true,
    });

    const columnsTranslations: Column<{}>[] = t(
        'week-3.more-about-emotions.emotionsTable.columns',
        {
            returnObjects: true,
        },
    );

    const dataSourceTranslations: DataSource[] = t(
        'week-3.more-about-emotions.emotionsTable.dataSource',
        {
            returnObjects: true,
        },
    );

    const dataSource = dataSourceTranslations.map((dataSourceTranslation, index: number) => ({
        key: dataSourceKeys[index],
        ...dataSourceTranslation,
    }));

    const columns = columnsData.map((columnData, index: number) => ({
        title: columnsTranslations[index],
        ...columnData,
    }));

    return (
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepHeading>{t('week-3.more-about-emotions.title')}</S.StepHeading>
                {descriptions.map((description: string) => (
                    <S.StepDescription small key={description}>
                        {description}
                    </S.StepDescription>
                ))}
            </S.ContentColumn>
            <S.StyledTable
                coloredFirstCol
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                scroll={{ x: 750 }}
            />
        </S.ContentRow>
    );
});
